import { makeStyles } from '@material-ui/core/styles';

import { greenMark } from 'theme';

export const useStyles = makeStyles(theme => ({
  checkIcon: {
    height: '18px',
  },
  // `color` here lands on a CheckCircleRoundedIcon, so it paints the glyph's
  // fill rather than any text.
  activeIcon: {
    color: greenMark,
  },
  stealthIcon: {
    color: theme.palette.common.orange400,
  },
  label: {
    width: 'fit-content',
    backgroundColor: theme.palette.common.gray200,
    color: theme.palette.common.gray800,
    borderRadius: '25px',
    padding: theme.spacing(0.5, 1),
    fontSize: '13px',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
  },
  active: {
    backgroundColor: theme.palette.common.green100,
  },
  stealth: {
    backgroundColor: theme.palette.common.orange100,
  },
  suggestion: {
    backgroundColor: theme.palette.common.infoTint,
  },
}));
